export default __webpack_public_path__ + "static/media/R4.7da45191.png";